import { useSearchParams } from 'react-router-dom';
import logo from 'src/assets/images/logos/logo-with-text-white.png';
import { RegisterModal } from 'src/components/common/Sidebar/RegisterModal/RegisterModal';
import styles from './Auth.module.scss';

export const Auth = () => {
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get('redirectUrl') ?? undefined;

  return (
    <div className={styles.backgroundSection}>
      <div className={styles.backgroundImage}></div>
      <div className={styles.backgroundOverlay}></div>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <span className={styles.branding}>
            <img alt="Dunbar148" src={logo}></img>
          </span>

          <span className={styles.spacer}></span>

          <span className={styles.content}>
            <div className={styles.card}>
              <RegisterModal redirectUrl={redirectUrl} />
            </div>
          </span>
        </div>
      </div>
    </div>
  );
};
